namespace RedBullMOBILE360.PushNotifications {
    export interface PushNotificationsPGRow {
        Id?: number;
        Notificationdate?: string;
        Sender?: string;
        Status?: number;
        Excelfilename?: string;
        Isexceluploaded?: number;
    }

    export namespace PushNotificationsPGRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Sender';
        export const localTextPrefix = 'PushNotifications.PushNotificationsPG';
        export const deletePermission = 'PushNotifications:PushNotificationsPG';
        export const insertPermission = 'PushNotifications:PushNotificationsPG';
        export const readPermission = 'PushNotifications:PushNotificationsPG';
        export const updatePermission = 'PushNotifications:PushNotificationsPG';

        export declare const enum Fields {
            Id = "Id",
            Notificationdate = "Notificationdate",
            Sender = "Sender",
            Status = "Status",
            Excelfilename = "Excelfilename",
            Isexceluploaded = "Isexceluploaded"
        }
    }
}
